export var mockFlagsList = {
  admin_portal_ip_restrictions: 'on',
  admin_portal_domain_restrictions: 'on',
  'new-mfa-pages': 'on',
  'show-passkeys-new': 'on',
  'groups-admin-box-new': 'on',
  'msp-all-accounts': 'on'
};